import { EventHelper } from "app/helpers/eventHelper";
import React from "react";
import { FormattedMessage } from "react-intl";

const Team1 = (props: Record<string, any>): React.JSX.Element => {
  const {
    data,
    eventIncidents,
    DangerZoneTextOnly,
    isHome,
    isAway,
    possibleVar,
    incidentType,
    dangerZoneState,
    showDangerText,
  } = props;

  return (
    <div className={`team-2 ${isAway ? "is-away" : ""}`}>
      <div
        title={data.participant2}
        className="popular-event-cell__label__bottom_team"
      >
        <span>{data.participant2}</span>
      </div>
      {EventHelper.isEventLive(data) &&
        !EventHelper.isEventLiveWithNoScore(data) &&
        data.isActive && (
          <div className="popular-event-cell__stats">
            <div className="popular-event-cell__stats__lhs">
              <div className="popular-event-cell__stats__side">
                <FormattedMessage tagName="span" id="events-away" />
              </div>
            </div>
            <div className="popular-event-cell__stats__rhs">
              {showDangerText && isAway && (
                <div className="is-away--stats">
                  <DangerZoneTextOnly
                    eventIncident={eventIncidents[0]}
                    className={data.isActive ? "active" : ""}
                    incidentType={incidentType}
                    dangerZoneState={dangerZoneState}
                    possibleVar={possibleVar}
                    isAway={isAway}
                    isHome={isHome}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      {!data.isActive && showDangerText && isAway && (
        <DangerZoneTextOnly
          eventIncident={eventIncidents[0]}
          incidentType={incidentType}
          dangerZoneState={dangerZoneState}
          possibleVar={possibleVar}
          isAway={isAway}
          isHome={isHome}
        />
      )}
    </div>
  );
};

export default Team1;
